import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Style from './styles.module.scss';

const AdTitle = ({ title, commonStyle, showProtectedLabel }) => (
  <div className={Style.adTitle}>
    {showProtectedLabel && <div className={Style.protectLabel} />}
    <div className={`${commonStyle.adTitleGrid} ${Style.title}`}>{title}</div>
  </div>
);

AdTitle.defaultProps = {
  title: '',
  showProtectedLabel: false,
};

AdTitle.propTypes = {
  title: PropTypes.string,
  commonStyle: PropTypes.objectOf(PropTypes.string).isRequired,
  showProtectedLabel: PropTypes.bool,
};

export default memo(AdTitle);
